import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { TFormErrorResponse } from '@shared/types';
import type { UpdateCandidateResumeRequest } from '../../types';
import { candidatesApi } from '../candidatesApi';
import { candidateMutationKeys, candidateQueryKeys } from '../queryKeys';

type UpdateCandidateResumeVariables = {
  candidateId: number;
  resumeId: number;
  request: UpdateCandidateResumeRequest;
};

export const useUpdateCandidateResume = () => {
  const queryClient = useQueryClient();

  return useMutation<
    unknown,
    AxiosError<TFormErrorResponse>,
    UpdateCandidateResumeVariables
  >({
    mutationKey: candidateMutationKeys.updateResume,
    mutationFn: ({ candidateId, resumeId, request }) =>
      candidatesApi.updateCandidateResume(candidateId, resumeId, request),
    onSuccess: async (_data, { candidateId, resumeId }) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: candidateQueryKeys.resume(candidateId, resumeId),
          exact: true,
        }),
        queryClient.invalidateQueries({
          queryKey: candidateQueryKeys.allResumes(candidateId),
        }),
      ]);
    },
  });
};
